export const newsPaneWidthPx = 380;
export const newsArticlePaddingXPx = 20;
export const newsTextWidthPx = newsPaneWidthPx - 2 * newsArticlePaddingXPx;

export const newsPaneWidth = { xs: 'calc(100vw - 32px)', sm: `${newsPaneWidthPx}px` };

export const newsBodyLineHeightPx = 20;

export const newsLinkColor = '#1565C0';
const newsLinkHoverColor = '#0D47A1';

export const newsBodyTextSx = {
    fontSize: 14,
    lineHeight: `${newsBodyLineHeightPx}px`,
    color: 'rgba(66, 66, 66, 1)',
    overflowWrap: 'anywhere',
    '& p': { margin: '0 0 8px' },
    '& p:last-child': { marginBottom: 0 },
    '& ul, & ol': { margin: '0 0 8px', paddingLeft: '20px' },
    '& a': { color: newsLinkColor, textDecoration: 'underline' },
    '& a:hover': { color: newsLinkHoverColor, textDecorationThickness: '2px' }
};
